import { gql } from '@apollo/client';

export const academyFragment = gql`
  fragment Academy on Academy {
    id
    name
    logoImagePath
    logoImageUrl
    features
  }
`;

export const academyProfessorFragment = gql`
  fragment AcademyProfessor on AcademyProfessor {
    id: _id
    name
    email
    active
    role {
      id: _id
      name
    }
  }
`;

export const academyRoleFragment = gql`
  fragment AcademyRole on AcademyRole {
    id: _id
    name
  }
`;
